<div class="relative flex flex-col w-full h-full max-h-128">
  <div class="absolute top-0 right-0 pt-4 pr-4">
    <button mat-icon-button mat-dialog-close="">
      <mat-icon class="text-secondary" svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>
  <div class="flex flex-col gap-4 grow py-4">
    <div class="text-2xl font-semibold tracking-tight">Оценить решение</div>
    <form class="flex flex-col gap-4" [formGroup]="formGroup">
      <div>
        <com-form-label
          text="Оценка"
          type="block"
          [required]="true"
        ></com-form-label>
        <com-form-input
          class="basis-4/12"
          [control]="formGroup.controls.userRating"
          type="number"
          placeholder="Введите значение"
          [min]="minUserRating"
          [max]="maxUserRating"
        ></com-form-input>
      </div>
      <div class="flex items-center justify-center sm:justify-end gap-4">
        <button mat-stroked-button mat-dialog-close="">Отмена</button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="formGroup.invalid"
          (click)="confirm()"
        >
          Подтвердить
        </button>
      </div>
    </form>
  </div>
</div>
